import React from 'react'
import { IMapComponents } from '../utility/types'
const HighlightSummaryCard = React.lazy(() => import('./HighlightSummaryCard'))
const BackgroundSummaryCard = React.lazy(() => import('./BackgroundSummaryCard'))

const mapComponents: IMapComponents = {
    HighlightSummaryCard,
    BackgroundSummaryCard
}

export default mapComponents